export default __webpack_public_path__ + "static/media/email.8b71563c.png";